import LoadingMixin from "../mixins/loading-mixin";
import TimerMixin from "../mixins/timer-mixin";

export default {
    mixins: [LoadingMixin, TimerMixin],
    data() {
        return {
            step: 'register',
            commonErrors: [],
            errors: [],
            isAgree: true,
            validEmail: false,
            hasMindboxData: false,
            name: '',
            lastName: '',
            email: '',
            code: ''
        }
    },
    created() {
        this.$store.dispatch('getMindboxUserData')
            .then((response) => {
                if (response.status === 'success') {
                    this.email = !!response.data.email ? response.data.email : ''
                    this.name = !!response.data.firstName ? response.data.firstName : ''
                    this.lastName = !!response.data.lastName ? response.data.lastName : ''

                    this.hasMindboxData = !!this.email || !!this.name || this.lastName
                }
            })
            .catch((errors) => {})
    },
    methods: {
        clearErrors() {
            this.commonErrors = []
            this.errors = []
        },
        clearError(fieldName) {
            if (!!this.errors[fieldName]) {
                this.errors[fieldName] = ''
            }
        },
        processErrors(errors) {
            if (errors.length > 0) {
                for (let error of errors) {
                    if (!!error.code) {
                        this.errors[error.code] = error.message
                    } else {
                        this.commonErrors.push(error.message)
                    }
                }
            }
        },
        register() {
            this.clearErrors()

            if (this.isAgree) {
                this.startLoader()

                this.$store.dispatch(
                    'registerUser',
                    {
                        name: this.name,
                        lastName: this.lastName,
                        email: this.email
                    }
                )
                    .then((response) => {
                        if (response.status === 'success') {
                            if (response.data['nextAction'] === 'auth') {
                                location.reload()
                            } else {
                                this.errors['email'] = this.$Bitrix.Loc.getMessage('JS_MS_AF_EMAIL_EXISTS_ERROR')
                                this.step = 'preconfirm';
                            }
                        }
                    })
                    .catch((errors) => {
                        this.processErrors(errors)
                    })
                    .finally(this.stopLoader)
            }
        },
        sendConfirmCode() {
            this.clearErrors()
            this.startLoader()

            this.$store.dispatch('sendEmailConfirmCode', this.email)
                .then((response) => {
                    if (response.status === 'success') {
                        this.startTimer()
                        this.step = 'confirm';
                    }
                })
                .catch((errors) => {
                    this.processErrors(errors)
                })
                .finally(this.stopLoader)
        },
        checkConfirmCode() {
            this.clearErrors()
            this.startLoader()

            this.$store.dispatch(
                'checkEmailConfirmCode',
                {
                    email: this.email,
                    code: this.code
                }
            ).then((response) => {
                if (response.status === 'success') {
                    this.register()
                }
            })
            .catch((errors) => {
                this.processErrors(errors)
            })
            .finally(this.stopLoader)
        },
        clearEmail() {
            this.clearErrors()
            this.email = ''
            this.step = 'register'
        }
    },
    // language=Vue
    template: `
      <div class="upblock__step">
      <div class="upblock__title">
        <span>{{$Bitrix.Loc.getMessage('JS_MS_AF_REGISTRATION')}}</span>
      </div>
      <small v-if="hasMindboxData && step === 'register'">
        {{$Bitrix.Loc.getMessage('JS_MS_AF_ALREADY_EXISTS')}}
      </small>
      <div class="upblock__body js-val-container">
        <div class="upblock__body-wrapper">
          
          <div class="b-form-field-errors"
               v-if="commonErrors.length > 0"
          >
            <div class="b-form-field-error"
                 v-for="(errorText, i) in commonErrors"
                 :key="i"
            >
              {{errorText}}
            </div>
          </div>
          
          <div class="b-form-field">
            <div class="b-form-field__wrapper">
              <input class="b-form-field__input" 
                     type="text" 
                     :placeholder="$Bitrix.Loc.getMessage('JS_MS_AF_NAME_PLACEHOLDER')" 
                     v-model="name">
            </div>
            <div class="b-form-field-error" 
                 v-if="errors['name']">
              {{errors['name']}}
            </div>
          </div>
          <div class="b-form-field">
            <div class="b-form-field__wrapper">
              <input class="b-form-field__input" 
                     type="text" 
                     :placeholder="$Bitrix.Loc.getMessage('JS_MS_AF_LAST_NAME_PLACEHOLDER')" 
                     v-model="lastName">
            </div>
            <div class="b-form-field-error"
                 v-if="errors['lastName']">
              {{errors['lastName']}}
            </div>
          </div>
          <div class="b-form-field">
            <div class="b-form-field__wrapper">
              <input class="b-form-field__input" 
                     type="email" 
                     @input="clearError('email')"
                     :placeholder="$Bitrix.Loc.getMessage('JS_MS_AF_EMAIL_PLACEHOLDER')" 
                     v-model="email">
            </div>
            <div class="b-form-field-error"
                 v-if="errors['email']">
              {{errors['email']}}
            </div>
          </div>
          <div class="b-form-field"
               v-if="step === 'confirm'"
          >
            <div class="b-form-field__wrapper">
              <input class="b-form-field__input" 
                     type="number" 
                     :placeholder="$Bitrix.Loc.getMessage('JS_MS_AF_CODE_PLACEHOLDER')" 
                     v-model="code">
            </div>
            <div class="b-form-field-error"
                 v-if="errors['code']">
              {{errors['code']}}
            </div>
            <div class="b-form-field-status">
              {{$Bitrix.Loc.getMessage('JS_MS_AF_EMAIL_CODE_SENT')}}
            </div>
          </div>
          
        </div>
        <div class="upblock__body-button js-btn-submit"
              :class="{'disabled': !isAgree}"
              @click="register"
              v-if="step === 'register' && !localLoading"
              :disabled="!isAgree || localLoading"
        >
          {{$Bitrix.Loc.getMessage('JS_MS_AF_REGISTER')}}
        </div>
        <div class="upblock__body-button js-btn-submit"
             @click="sendConfirmCode"
             v-if="step === 'preconfirm' && !localLoading"
        >
          {{$Bitrix.Loc.getMessage('JS_MS_AF_CONFIRM')}}
        </div>
        <div class="upblock__body-button js-btn-submit"
             @click="checkConfirmCode"
             v-if="step === 'confirm' && !localLoading"
        >
          {{$Bitrix.Loc.getMessage('JS_MS_AF_CONFIRM')}}
        </div>
        <div class="upblock__body-button js-btn-submit on-load"
             v-else-if="localLoading"
        >
          {{$Bitrix.Loc.getMessage('JS_MS_AF_WAITING')}}
        </div>
        <div class="upblock__checkboxes"
             v-if="step === 'register'">
          <div class="upblock__checkbox">
            <div class="b-form-field b-form-field--checkbox">
              <label class="b-form-field__label">
                <input type="checkbox" v-model="isAgree">
                <div class="b-form-field__caption">
                  Я подтверждаю свое согласие с условиями Пользовательского
                  соглашения, <a href="#">Правилами программы лояльности</a> и согласен(-на) на обработку
                  персональных данных согласно правилам <a href="/offer/">пользовательского соглашения</a>
                </div>
              </label>
            </div>
          </div>
        </div>
        <p class="upblock__bottom-text"
           style="font-size: 14px"
           v-if="step !== 'register'"
        >
          {{$Bitrix.Loc.getMessage('JS_MS_AF_OR')}}&nbsp;<a @click="clearEmail">{{$Bitrix.Loc.getMessage('JS_MS_AF_ANOTHER_EMAIL')}}</a>
        </p>
        <p class="sub-t"
           v-if="step === 'confirm'">
            <small v-if="currentTime > 0">{{$Bitrix.Loc.getMessage('JS_MS_AF_COUNTER_TEXT', {'#CURRENT_TIME#': this.currentTime})}}</small>
            <a v-else
               @click="sendConfirmCode"
            >
              <small>{{$Bitrix.Loc.getMessage('JS_MS_AF_RESEND_CODE')}}</small>
            </a>
        </p>
      </div>
      </div>
    `
}